import { render } from "./CoinDropdownSkeleton.vue?vue&type=template&id=84611622"
import script from "./CoinDropdownSkeleton.vue?vue&type=script&lang=js"
export * from "./CoinDropdownSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__